import { useState, useEffect } from 'react'
import { Grid, TextField, InputAdornment, Tooltip, Typography } from '@mui/material'
import { Icon } from 'components'

interface AddVehicleDialogBodyProps {
  onSubmit: (vin: string) => void
}

const AddVehicleDialogBody: React.FC<AddVehicleDialogBodyProps> = ({ onSubmit }) => {
  const [vin, setVin] = useState<string>('')

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
  }

  useEffect(() => {
    if (vin.trim()) {
      onSubmit(vin.trim())
    }
  }, [vin, onSubmit])

  return (
    <Grid display="flex" flexDirection="column" gap={2}>
      <Typography variant="body1" sx={{ color: '#6B7280', mb: 3 }}>
        Enter the VIN of the vehicle you want to add to your policy. We'll automatically match it with telematics data if available.
      </Typography>
      <Typography variant="h6" sx={{ color: '#000', mb: 2 }}>
        Vehicle Identification Number (VIN)
      </Typography>
      <TextField
        value={vin}
        onChange={(e) => setVin(e.target.value)}
        placeholder="E.G. 1HGBH41JXMN109186"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon materialIcon="DirectionsCar" />
            </InputAdornment>
          ),
          endAdornment: vin ? (
            <Tooltip title="Copy VIN">
              <InputAdornment position="end">
                <Icon
                  materialIcon="ContentCopy"
                  iconButton={true}
                  onClick={() => copyToClipboard(vin)}
                />
              </InputAdornment>
            </Tooltip>
          ) : null,
        }}
        fullWidth
        variant="outlined"
      />
    </Grid>
  )
}

export default AddVehicleDialogBody 